<script setup lang="ts">

import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import { computed, defineProps } from 'vue'
import { usePlanetStore } from '@/stores/planetStore.ts'
import BuildingRequired from '@/components/Sections/Planets/PlanetTabs/Generic/BuildingRequired.vue'
import GenericIconWithColoredNumber from '@/components/Elements/Images/Icons/GenericIconWithColoredNumber.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

/**
 * Props
 */
const props = defineProps({
  planetId: {
    type: Number,
    required: true
  }
});

/**
 * Stores / models
 */
const planetStore = usePlanetStore()

/**
 * Computed
 */
const planetData = computed(() => planetStore.findPlanetById(props.planetId)!)

</script>

<template>
  <StandardCard :title="t('planets.defense.active.title')" topPadding="2" :help="t('planets.defense.active.help')">
    <div v-if="planetData.attackAgainstShips===0">
      <BuildingRequired :text="t('planets.defense.active.buildFirst')" building-code="orbital_laser_array"/>
    </div>
    <div v-else class="flex justify-center">
      <div class="p-2 rounded text-center flex flex-col flex-shrink-0">
        <div class="pb-3 text-slate-300">{{ t('planets.defense.active.attackStrength') }}</div>
        <GenericIconWithColoredNumber :amount="planetData.attackAgainstShips" type="defense_attack_ships" class="self-center"/>
      </div>
    </div>
  </StandardCard>
</template>

<style scoped lang="scss">

</style>